import { axios, Response } from '../index'

export interface Body {
  name: string
  macroAreaId: string
  posX: number
  posY: number
}

const updatePoint = (id: string, request: Body): Response<null> => {
  return axios.put(`/v1/body-points/${id}`, request)
}

export default updatePoint
